/**
 * @typedef {Object} ToothDO
 * @property {string} toothGumType - The type of tooth gum (UPPER or LOWER)
 * @property {number} toothNumber - The tooth number
 * @property {string} fileUrl - URL of the tooth file
 * @property {string} fileType - Type/extension of the file
 * @property {string} filePath - Full file path
 */

/**
 * @type {ToothDO[]}
 */
const toothDOListSingle = [];

/**
 * @param {ToothDO} toothDO
 */
const addToothDO = (toothDO) => {
  toothDOListSingle.push(toothDO);
};

const getToothDOList = () => {
  return toothDOListSingle;
};

export default {
  addToothDO,
  getToothDOList,
};
